<template>
  <!-- TODO: Show applications in order of being active IE phases, unsuccessful, withdrawn -->
  <v-card class="candidate dashboard-applications mt-4">
    <v-card-title class="pt-4" :class="themes.candidate.light.dialogTitle">
      <div>
        <div class="title">My Applications</div>
        <div class="subheading" :class="themes.candidate.light.cardSubtitle">
          A list of all your past and present applications
        </div>
      </div>
      <v-spacer />
      <v-tooltip left v-if="!loading && completionCalculated">
        <v-btn
          icon
          slot="activator"
          :color="themes.candidate.light.primaryActionButton"
          @click="refreshCompletion"
        >
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
        <span>Recalculate completion</span>
      </v-tooltip>
    </v-card-title>

    <v-progress-linear
      indeterminate
      v-if="loading"
      :height="5"
      :color="themes.candidate.light.loading"
      class="ma-0"
    />

    <v-card-text
      v-for="(application, i) in sortedApplications"
      :key="`application-${application.id}`"
    >
      <v-divider v-if="i > 0" />
      <v-card flat tile class="candidate application-card">
        <v-card-text>
          <!-- Card Title -->
          <v-list avatar>
            <v-list-tile>
              <v-list-tile-avatar>
                <v-avatar slot="activator" size="50">
                  <img :src="application.opportunity.organization.logo" />
                </v-avatar>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title>
                  {{ application.opportunity.name }}
                </v-list-tile-title>
                <v-list-tile-sub-title>
                  {{ application.opportunity.organization.name }}
                </v-list-tile-sub-title>
              </v-list-tile-content>
              <v-list-tile-action
                v-if="
                  ['Withdrawn', 'Unsuccessful', 'Successful'].indexOf(
                    application.status
                  ) >= 0
                "
              >
                <v-tooltip left v-if="!application.archivedAt">
                  <v-btn
                    icon
                    slot="activator"
                    :ref="`archiveBtn-${application.id}`"
                    @click="archive(application)"
                  >
                    <v-icon :color="themes.candidate.light.muted"
                      >mdi-package-down</v-icon
                    >
                  </v-btn>
                  <span>Archive Application</span>
                </v-tooltip>
                <span
                  v-else
                  class="caption"
                  :class="themes.candidate.light.mutedText"
                >
                  Archived
                </span>
              </v-list-tile-action>
            </v-list-tile>
          </v-list>

          <!-- Phase Stepper -->
          <PhaseStepper :application="application" />

          <div class="text-xs-right">
            <v-btn
              v-if="
                application.status !== 'Withdrawn' &&
                application.status !== 'Unsuccessful'
              "
              @click="
                openChat({
                  opportunityName: application.opportunity.name,
                  organizationName: application.opportunity.organization.name,
                })
              "
              :color="themes.candidate.light.dangerButton"
              flat
            >
              Withdraw
            </v-btn>
            <!-- Withdraw Dialog -->
            <!-- <v-dialog lazy absolute -->
            <!--   v-if="application.status !== 'Withdrawn' && application.status !== 'Unsuccessful'" -->
            <!--   v-model="withdrawDialog" -->
            <!--   max-width="300px" -->
            <!-- > -->
            <!--   <v-btn flat :color="themes.candidate.light.dangerButton" slot="activator"> -->
            <!--     Withdraw -->
            <!--   </v-btn> -->
            <!--   <v-card> -->
            <!--     <v-card-title class="headline" :class="themes.candidate.light.dialogTitle"> -->
            <!--       Are you sure? -->
            <!--     </v-card-title> -->
            <!--     <v-card-text> -->
            <!--       To withdraw your application means that you are no longer interested in the -->
            <!--       opportunity. -->
            <!--     </v-card-text> -->
            <!--     <v-card-text> -->
            <!--       This will remove your application and -->
            <!--       <strong>you won't be able to apply for this opportunity again.</strong> -->
            <!--     </v-card-text> -->
            <!--     <v-card-actions> -->
            <!--       <v-btn flat block -->
            <!--         :color="themes.candidate.light.cancel" -->
            <!--         @click.native="withdrawDialog = false" -->
            <!--         v-text="'Cancel'" -->
            <!--       /> -->
            <!--       <v-btn flat block -->
            <!--         v-text="'Withdraw'" -->
            <!--         :color="themes.candidate.light.danger" -->
            <!--         @click="withdraw(application)" -->
            <!--         :loading="application.loading" -->
            <!--       /> -->
            <!-- </v-card-actions> -->
            <!-- </v-card> -->
            <!-- </v-dialog> -->

            <!-- Withdrawn date -->
            <span
              v-else
              :class="themes.candidate.light.errorText"
              class="caption"
            >
              <span v-if="application.status === 'Withdrawn'">
                Withdrawn
                {{ new Date(application.withdrawnAt) | date("d MMMM YYY") }}
              </span>
              <span v-else>
                Regretted
                {{ new Date(application.regrettedAt) | date("d MMMM YYY") }}
              </span>
            </span>

            <!-- View Button -->
            <v-btn
              :color="themes.candidate.light.secondaryActionButton"
              :to="`/candidate/applications/${application.id}`"
            >
              View Application
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-card-text>

    <v-card-text
      v-if="!applications.length"
      :class="themes.candidate.light.mutedText"
      class="subheading"
    >
      You don't have any applications yet
    </v-card-text>
    <v-divider v-if="!applications.length || anyArchived" />
    <v-card-actions>
      <v-btn
        v-if="!applications.length"
        :color="themes.candidate.light.primaryActionButton"
        v-text="'Search for Opportunities'"
        to="/opportunities"
        block
        flat
      />
      <v-btn
        v-if="anyArchived"
        @click="showArchived = !showArchived"
        :color="themes.candidate.light.secondaryActionButton"
        block
        flat
      >
        <v-icon left>mdi-package-down</v-icon>
        {{ showArchived ? "Hide" : "Show" }} Archived
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
// Components
import PhaseStepper from "@/components/candidate/applications/PhaseStepper";

// Helpers
import { mapActions, mapGetters } from "vuex";
import _ from "lodash";

// Vue Component
export default {
  components: { PhaseStepper },

  created() {
    this.$store
      .dispatch("candidate/applications/fetchAll")
      .finally(() => (this.loading = false));
  },
  data() {
    return {
      loading: true,
      showArchived: false,
      withdrawDialog: false,
    };
  },
  watch: {
    // Programmatically trigger the tooltip once after apps render to ensure correct positioning
    applications: {
      handler(apps) {
        if (!apps || !apps.length) return;
        this.$nextTick(() => {
          apps.forEach((a) => {
            const isInactive =
              ["Withdrawn", "Unsuccessful", "Successful"].indexOf(a.status) >=
              0;
            if (isInactive && !a.archivedAt) {
              this.triggerArchiveTooltip(a.id);
            }
          });
        });
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    ...mapGetters({
      applications: "candidate/applications/all",
    }),

    anyArchived() {
      const applications = JSON.parse(JSON.stringify(this.applications));

      return (
        applications.filter((a) => a.archivedAt && a.archivedAt.length).length >
        0
      );
    },

    completionCalculated() {
      return this.applications.every((a) => a.completion !== null);
    },

    sortedApplications() {
      const applications = JSON.parse(JSON.stringify(this.applications));

      return applications
        .filter((a) => {
          return (
            _.get(a, "opportunity.organization") &&
            (!a.archivedAt || this.showArchived)
          );
        })
        .sort(({ createdAt: a }, { createdAt: b }) => {
          if (new Date(a) < new Date(b)) return 1;
          if (new Date(a) > new Date(b)) return -1;
          return 0;
        });
    },

    questionnaires() {
      if (
        this.application &&
        this.application.opportunity &&
        this.application.opportunity.phases
      ) {
        const phases = this.application.opportunity.phases.filter(
          (phase) => phase.behaviors
        );
        const sets = [];
        phases.forEach((phase) => {
          phase.behaviors.forEach((behavior) => {
            if (behavior.type === "OpportunityPhaseBehavior::Questionnaire") {
              sets.push(
                Object.assign(behavior, {
                  phase: { id: phase.id, name: phase.name },
                })
              );
            }
          });
        });
        return sets;
      } else {
        return [];
      }
    },
  },
  methods: {
    ...mapActions({
      archive: "candidate/applications/archive",
    }),

    // Trigger a synthetic hover on the archive button so Vuetify positions the tooltip correctly
    triggerArchiveTooltip(id) {
      try {
        const ref = this.$refs[`archiveBtn-${id}`];
        const comp = Array.isArray(ref) ? ref[0] : ref;
        const el = comp && (comp.$el || comp);
        if (!el || typeof el.dispatchEvent !== "function") return;
        // Wait two frames to ensure layout is stable before opening
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            el.dispatchEvent(new MouseEvent("mouseenter", { bubbles: true }));
          });
        });
      } catch (e) {
        // no-op
      }
    },

    openChat({ opportunityName, organizationName }) {
      if (!window.CRISP_READY) return;

      $crisp.push(["do", "chat:open"]);
      $crisp.push([
        "do",
        "message:send",
        [
          "text",
          opportunityName
            ? `Hi! I would like to withdraw my application from ${opportunityName} at ${organizationName}. Can you help me?`
            : "Hi! I would like to withdraw one of my applications. Can you help me?",
        ],
      ]);
    },

    refreshCompletion() {
      this.loading = true;
      this.$store
        .dispatch("candidate/profile/refreshCompletion")
        .then(() => {
          return this.$store.dispatch("candidate/applications/fetchAll");
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>

<style>
div.v-list__tile {
  padding-right: 5px;
}
</style>
